"use client";

import Image from "next/image";
import React, { useState } from "react";

export function ProfileAvatar({
  className = "size-8",
  profilePictureUrl = null,
}: {
  readonly className?: string;
  readonly profilePictureUrl?: string | null;
}) {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const customPicture =
    profilePictureUrl === null || failedUrl === profilePictureUrl
      ? null
      : profilePictureUrl;

  return (
    <Image
      src={customPicture ?? "/profile/default-profile-avatar.svg"}
      alt=""
      width={64}
      height={64}
      unoptimized={customPicture !== null}
      onError={
        customPicture === null ? undefined : () => setFailedUrl(customPicture)
      }
      className={`shrink-0 rounded-full border border-border-subtle bg-logo object-cover ${className}`}
    />
  );
}
